import { has, isArray } from 'lodash';
import { escapeInput } from '../../utils/request';
import { updateAutoSaveDraft } from '../../api/reports';
import postDraftReport from 'APP_ROOT/actions/post-draft-report';
import syncFormValueChanged from 'APP_ROOT/actions/sync-form-value-changed-boolean';
import { setLastSaveDate } from 'APP_ROOT/actions/set-last-save-date';

const autoSave = async (id, agencyId, data, dispatch) => {
  try {
    dispatch(syncFormValueChanged(false));
    await updateAutoSaveDraft(id, agencyId, data);
    dispatch(setLastSaveDate(new Date()));
  } catch (e) {
    console.warn('Sorry something bad happen!'); // eslint-disable-line
  }
};

export async function manualAutoSave(id, agencyId, data) {
  try {
    const formattedData = formatData(data);
    await updateAutoSaveDraft(id, agencyId, formattedData);
  } catch (e) {
    console.warn('Sorry something bad happen!'); // eslint-disable-line
  }
}

export function getChangedFieldName(data, parentKey, key, repeater) {
  if (parentKey) {
    // Logic for repeaters
    const repeaterData = data[parentKey];
    // Example value of the repeater param: repeaterRepeater98[0].fieldAutocomplete609
    const bracketIndex = repeater.indexOf(']') - 1;
    const index = parseInt(repeater.charAt(bracketIndex));

    const item = repeaterData && repeaterData[index];
    if (!item || !item.id) {
      return key;
    }

    const repeaterId = item.id;
    const delimiter = '.';
    return parentKey.concat(delimiter, repeaterId).concat(delimiter, key);
  }

  return key;
}

export const formatData = changedFields => {
  const data = { ...changedFields };
  return Object.keys(data).reduce((cleanedData, key) => {
    if (isArray(data[key])) {
      cleanedData[key] = data[key]
        .filter(key => key !== null)
        .map(value => {
          if (typeof value === 'object') return formatData(value);
          return value;
        });
    } else if (typeof data[key] === 'object') {
      cleanedData[key] = has(data[key], '_d')
        ? Object.values(data).join()
        : data[key];
      if (has(data[key], '_isAMomentObject'))
        cleanedData[key] = data[key]['_d'];
    } else {
      cleanedData[key] = data[key];
    }
    return cleanedData;
  }, {});
};

const saveDraft = (dispatch, selectedForm, cb = () => {}, autoSave = false) => {
  const { data: fields } = selectedForm;
  const data = formatData(fields);
  dispatch(postDraftReport(data, cb, autoSave));
};

const autoSaveDraft = (meta, changedFields, dispatch, changedFieldName) => {
  const { id, agencyId } = meta;
  const data = formatData(changedFields);
  const escapedData = escapeInput(data);
  const isValueNull = Object.values(escapedData).find(value => value === null);
  data['changedFieldName'] = changedFieldName;
  if (typeof isValueNull === 'undefined')
    autoSave(id, agencyId, data, dispatch);
};

export const autoSaveDraftReport = (
  isDraftSaved,
  selectedForm,
  changedFields,
  isDraftJustSaved,
  dispatch,
  canRetry = false
) => {
  const { changedFieldName, meta } = selectedForm;
  const isDraftCreated = has(meta, 'id');
  // canRetry: allow autosave continue working until the form is created. (safe retry)
  if ((!isDraftSaved && !isDraftJustSaved && !isDraftCreated) || canRetry)
    saveDraft(dispatch, selectedForm, undefined, true);
  else if (isDraftCreated)
    autoSaveDraft(meta, changedFields, dispatch, changedFieldName);
};
